import axios from 'axios';

// יצירת Axios
const api = axios.create({
    baseURL: '/api/',
    headers: {
        "Content-Type": "application/json"
    }
});

// לפני כל בקשה לשרת:
// אם קיים JWT ב-localStorage, הוא יישלח אוטומטית
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// אחרי כל תשובה מהשרת:
// אם התקבלה שגיאת 401 - המשתמש מועבר להתחברות
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {

            localStorage.removeItem("token");
            localStorage.removeItem("tokenExpirationTime");
            localStorage.removeItem("loggedUser");
            localStorage.removeItem("isAdmin");

            if (window.location.pathname !== "/signIn") {
                window.location.href = "/signIn";
            }
        }

        return Promise.reject(error);
    }
);

// ייצוא
export default api;